/**
 * JSON-LD Schema Block — Content Schema
 *
 * Defines the editable tokens for the structured data block.
 * Uses 'text' type with 'true'/'false' string values for boolean toggles
 * (matches existing block patterns — see google-maps-places).
 */

import type { ComponentContentSchema } from '@vibesites/runtime';

export const contentSchema: ComponentContentSchema = {
  slot: 'JsonLdSchema',
  displayName: 'Multihub Site Schema',
  tokens: {
    schema_types: {
      label: 'Schema Types',
      type: 'text',
      defaultValue: 'ApartmentComplex,LocalBusiness',
      description: 'Comma-separated @type values (e.g. "ApartmentComplex,LocalBusiness").',
    },
    include_reviews: {
      label: 'Include Reviews',
      type: 'text',
      defaultValue: 'true',
      description: 'Include aggregateRating and review data from the reviews collection.',
    },
    include_floorplans: {
      label: 'Include Floorplans',
      type: 'text',
      defaultValue: 'true',
      description: 'Include floorplan data as Accommodation offers.',
    },
    include_amenities: {
      label: 'Include Amenities',
      type: 'text',
      defaultValue: 'true',
      description: 'Include amenities as amenityFeature entries.',
    },
    include_office_hours: {
      label: 'Include Office Hours',
      type: 'text',
      defaultValue: 'true',
      description: 'Include openingHoursSpecification from office hours.',
    },
    include_gallery: {
      label: 'Include Gallery',
      type: 'text',
      defaultValue: 'true',
      description: 'Include photo gallery images.',
    },
    include_special_offers: {
      label: 'Include Special Offers',
      type: 'text',
      defaultValue: 'true',
      description: 'Include active special offers.',
    },
    override_name: {
      label: 'Override: Name',
      type: 'text',
      defaultField: 'property_name',
      description: 'Override the schema "name" value.',
    },
    override_description: {
      label: 'Override: Description',
      type: 'text',
      defaultField: 'property_short_description',
      description: 'Override the schema "description" value.',
    },
    override_phone: {
      label: 'Override: Phone',
      type: 'phone',
      defaultField: 'property_phone',
      description: 'Override the schema "telephone" value.',
    },
    override_url: {
      label: 'Override: URL',
      type: 'url',
      defaultField: 'property_website_url',
      description: 'Override the schema "url" value.',
    },
    override_image: {
      label: 'Override: Image',
      type: 'image',
      defaultField: 'property_featured_image',
      description: 'Override the primary schema image.',
    },
    custom_json: {
      label: 'Custom JSON Override',
      type: 'text',
      defaultValue: '',
      description: 'Paste a full JSON-LD object to replace the auto-generated schema entirely.',
    },
  },
};
